export const switchContentsBasedOnScanCountry = (scanCountry) => {
  if(scanCountry && scanCountry!==''){
    scanCountry = scanCountry.trim();
    $("[data-scan-country-group]").each((i, e) => {
      let elementThatMatchedScanCountry = Array.from(e.children).find(c=> c.attributes['data-for-scan-country'] 
                                            && c.attributes['data-for-scan-country'].value === scanCountry );
        let childs = $(e).children();
        childs.each((index, childElement) => {
        let dataForScanCountryAttr = childElement.attributes['data-for-scan-country'];
        if(dataForScanCountryAttr && dataForScanCountryAttr.value){
          const dataForScanCountryVal = dataForScanCountryAttr.value.trim();

          if(dataForScanCountryVal !== ''){
            if(elementThatMatchedScanCountry){
              if(dataForScanCountryVal !== scanCountry){
                $(childElement).css({display:"none"});
              }else{
                $(childElement).css({display:"block"});
              }
            } else{
              if(dataForScanCountryVal !== 'Others'){
                $(childElement).css({display:"none"});
              } else{
                $(childElement).css({display:"block"});
              }
            }
          }
        }
      });
    });
  }
}
